export default __webpack_public_path__ + "static/telepointers-dark-dc6734aaced040f7ba15b8e101ded842.png";